import { i18n } from '@lingui/core'

export type TranslationBundle = 'customer' | 'flow'

type Config = {
  language: GLOBALS.Language
  translationBundle?: TranslationBundle
}

const DEFAULT_LANG: Config['language'] = 'en'

export const setupI18n = async ({
  language = DEFAULT_LANG,
  translationBundle = 'customer',
}: Config) => {
  const [common, app] = await Promise.all([
    import(
      /* webpackChunkName: "[request]" */ `../../../public/locale/${language}/common-messages`
    ),
    import(
      /* webpackChunkName: "[request]" */ `../../../public/locale/${language}/${translationBundle}-messages`
    ),
  ])

  i18n.load(language, { ...common.messages, ...app.messages })
  i18n.activate(language)
}
